// import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { Router } from '@angular/router';
import { SsoService } from '../../shared/services/sso.service';
import { RouteContextProvider } from '../services/routeContextProvider.service';
import { SessionHandlerService } from '../services/sessionHandler.service';
import { Formatter } from '../services/formatter';
import { CommonConstants } from './commonConstants';
import { HomeService } from 'src/app/home/home.service';
import { CookieHandlerService } from '../services/cookieHandler.service';


@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  public fedToken: string;
  public key: string;
  public productCode: string;
  backFlow: string;
  constructor(
    private ssoService: SsoService,
    private router: Router,
    private _routeContextProvider: RouteContextProvider,
    private _sessionHandlerService: SessionHandlerService,
    private formatter: Formatter,
    private _homeService: HomeService,
    private _cookieHandler: CookieHandlerService
  ) {
    this.productCode = CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance;
  }

  /* Auth guard scope */
  // Async operations to be performed here
  // 1. Read URL params (fed token) and ecrypted key (Mobile number|First name|Last name)
  // 2. Validate fed token () - isFedTokenValid
  // if valid then resume below steps else navigate to insurance mall journey
  // 3. Register API to be called - retrieve customer token, save it session/cookie, save flag for SSO in session - customerTokenReceived
  // if (isFedTokenValid && customerTokenReceived) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  /* Auth guard scope */

  /* Vehicle registration component scope */
  // 4. Navigate to GetQoute page
  // 5. On ngInit Check SSO session flag
  // 6. If SSO session flag is true Call Demog API and prefill data on get quote page - On get quote page else resume journey normally
  /* Vehicle registration component scope */

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {
      // Identify if it's a web journey then proceed below code, else return true
      this.fedToken = route.queryParams['token'];
      this.key = encodeURI(route.queryParams['key']) || '';
      this.backFlow = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.backFlow);
      let accessToken = this._cookieHandler.GetCookie('accessToken');
      const isMobile = route.queryParams[CommonConstants.QueryParamsKeys.IsMobile] === '1' || this._sessionHandlerService.GetSession('source') === 'mobileApp';
      if (isMobile || (this.backFlow && this.fedToken) || !(this.fedToken || accessToken)) {
        // if (isMobile) {
        this.disableSsoFlow();
        resolve(true);
      } else {
        this.ssoService.GetSystemAuthToken({
          'productCode': this.productCode
        }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
          const systemTokenObj = responseData.payload.tokens[0];

          const validateSsoPayload = {
            'federatedToken': this.fedToken,
            'key': this.key
          };
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, systemTokenObj.token);
          if(accessToken) {
            let moPayload = {
                "accessToken": accessToken
              };
            this.ssoService.moTokenValidationAPI(moPayload).subscribe((moResponse: any)=>{
                console.log('moResponse----->>>', moResponse);
                if(moResponse?.customerAuthToken) {
                  this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, moResponse?.customerAuthToken);
                  this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.mobile_number, moResponse?.mobileNumber);
                  this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.ssoEnabled, true);
                } else {
                  this.disableSsoFlow();
                }
                resolve(true);
            });
          } else {
          this.ssoService.validateSsoToken(validateSsoPayload, (state, response) => {
            console.log('response', response, state);
            if (state == 'success') {
              if (response && (response?.status != '201')) {
                this.disableSsoFlow();
                resolve(true);
              } else {
                console.log('response', response);
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.mobile_number, response?.payload?.mobileNumber);
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.ssoEnabled, true);
                if (response?.headers) {
                  const authToken = response.headers.get('authtoken');
                  if (authToken !== null && authToken !== '') {
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, authToken);
                  }
                }
                resolve(true);
              }
            } else {
              this.disableSsoFlow();
              resolve(true);
            }
          });
        }
        });
      }
    });
  }

  validateKeyAndResponse(decryptedValue: string, responseObject: any) {
    const decryptedValuesArray = decryptedValue.toString().replace('"', '').replace('"', '').split("|");
    if (decryptedValuesArray[0] === responseObject?.payload?.mobile &&
      decryptedValuesArray[1] === responseObject?.payload?.firstName &&
      decryptedValuesArray[2] === responseObject?.payload?.lastName) {
      return true;
    } else {
      return false;
    }
  }

  disableSsoFlow() {
    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.ssoEnabled, false);
  }
}